@if (showFooter() || isOwner()) {
  <div class="footer" [class.footer--secondary]="variant() === 'secondary'">
    @if (showFooter()) {
      <div class="actions">
        @if (!isOwner()) {
          <button
            type="button"
            class="like action"
            [class.need-login]="!currentUser()"
            [class.is-liked]="item().is_liked_by_me"
            (click)="likePost($event)"
            (openGuestView)="onOpenGuestView()"
            dataTest="btn-recommend"
          >
            <outlaw-icon class="icon-svg" [name]="item().is_liked_by_me ? 'recommendFilled' : 'recommend'" />
            {{ item().is_liked_by_me ? 'Recommended' : 'Recommend' }}
          </button>
        }

        @if (canDisplayComments) {
          @if (postUrl()) {
            <a
              [href]="postUrl()"
              class="comments-amount"
              target="_blank"
              (click)="onNavigateToPost($event, isMajiWebview)"
              dataTest="btn-comments-toggle"
            >
              <ng-container *ngTemplateOutlet="commentsInfo"></ng-container>
            </a>
          } @else {
            <div class="comments-amount no-link" dataTest="btn-post-comments-count">
              <ng-container *ngTemplateOutlet="commentsInfo"></ng-container>
            </div>
          }
        }

        @if (currentUser() && !isMajiWebview && canDisplaySelections) {
          <outlaw-selections-menu
            [selections]="selections()"
            [isOpen]="selectionsMenuOpen()"
            [postUuid]="item().post_uuid"
            (selectionToggled)="toggleSelection($event)"
            (createClicked)="createNewSelection()"
            (closed)="closeSelectionsMenu()"
            (menuMouseEnter)="onMenuMouseEnter()"
            (menuMouseLeave)="onMenuMouseLeave()"
          >
            <button
              type="button"
              class="save action"
              [class.is-saved]="isSavedDisplay()"
              (click)="savePost($event)"
              (mouseenter)="onSaveHover()"
              (mouseleave)="onSaveLeave()"
              dataTest="btn-post-save"
            >
              <outlaw-icon class="icon-svg" [name]="isSavedDisplay() ? 'bookmarkFilled' : 'bookmark'" />
              {{ isSavedDisplay() ? 'Saved' : 'Save' }}
            </button>
          </outlaw-selections-menu>
        }

        @if (!isMajiWebview) {
          <button type="button" class="share action" (click)="sharePost()" dataTest="btn-post-share">
            <outlaw-icon class="icon-svg" name="share" />
          </button>
        }
      </div>
    }
    @if (canDisplayOwnerActions && !isMajiWebview) {
      <app-owner-actions [item]="item()" (event)="ownerAction.emit($event)" />
    }
  </div>
}

<ng-template #commentsInfo>
  <outlaw-icon class="icon-svg" name="comment" />
  @if (commentsAmount) {
    <div class="amount">{{ commentsAmount }}</div>
  }
</ng-template>
